import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[settingsPanelRenderer]',
  standalone: true,
})
export class SettingsPanelRendererDirective {

  public $type = input.required<string>({ alias: 'settingsPanelRenderer' });

  public template = inject(TemplateRef);
}
